import { getEnv } from "./utilities/env";

export const loadConfig = async () => {
  const clientName = getEnv("REACT_APP_CLIENT");

  const response = await fetch(`/client-configs/${clientName}.json`);
  const config = await response.json();

  window.AppConfig = config;  // store globally

  return config;
};
